import { useComposerState } from '#pplx/frontend/composer-sdk/internal/input-state/useComposerState.js';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { mergeRegister } from '@lexical/utils';
import { BLUR_COMMAND, COMMAND_PRIORITY_LOW, FOCUS_COMMAND } from 'lexical';
import React, { useEffect } from 'react';
/**
 * Mounts inside `LexicalComposer` and keeps `ComposerProvider`'s `isActive`
 * flag in sync with real editor DOM focus, so focused chrome and focus-scoped
 * behavior follow actual focus. Observes at low priority without consuming,
 * leaving the commands available to other handlers.
 */
export const FocusTrackerPlugin = function FocusTrackerPlugin() {
    const [editor] = useLexicalComposerContext();
    const { setActive } = useComposerState();
    useEffect(() => {
        // Focus can land before this effect registers (for example a pre-effect
        // focus gesture), so seed from live DOM state instead of assuming blurred.
        const rootElement = editor.getRootElement();
        const isActive = rootElement !== null && rootElement.ownerDocument.activeElement === rootElement;
        setActive(isActive);
        return mergeRegister(editor.registerCommand(FOCUS_COMMAND, () => {
            setActive(true);
            return false;
        }, COMMAND_PRIORITY_LOW), editor.registerCommand(BLUR_COMMAND, () => {
            setActive(false);
            return false;
        }, COMMAND_PRIORITY_LOW));
    }, [editor, setActive]);
    return null;
};
//# sourceMappingURL=FocusTrackerPlugin.js.map